import { api } from './client'

/**
 * R5-03 (E-04): gestione dell'elenco delle fonti dei lead (`api/lead-source-definitions`), solo Admin e solo con il
 * flag `leads.fonti_modificabili` acceso (spento: 404). Il codice non cambia mai; una fonte usata non si elimina.
 */
export interface LeadSourceDefinition {
  id: number
  code: string
  label: string
  channel: string
  sortOrder: number
  isActive: boolean
  isStandard: boolean
  uses: number
}

export interface LeadSourceDefinitionList {
  channels: string[]
  items: LeadSourceDefinition[]
}

export interface LeadSourceDefinitionBody {
  code?: string | undefined
  label: string
  channel: string
  sortOrder?: number | undefined
  isActive?: boolean
}

export const CHANNEL_LABELS: Record<string, string> = {
  digitale: 'Digitale',
  telefonico: 'Telefonico',
  commerciale: 'Commerciale',
  partner: 'Partner',
  altro: 'Altro',
}

export const leadSourcesApi = {
  list: () => api<LeadSourceDefinitionList>('/api/lead-source-definitions'),
  create: (body: LeadSourceDefinitionBody) =>
    api<LeadSourceDefinition>('/api/lead-source-definitions', { method: 'POST', body: JSON.stringify(body) }),
  update: (id: number, body: LeadSourceDefinitionBody) =>
    api<LeadSourceDefinition>(`/api/lead-source-definitions/${id}`, { method: 'PUT', body: JSON.stringify(body) }),
  delete: (id: number) => api<void>(`/api/lead-source-definitions/${id}`, { method: 'DELETE' }),
}
